// Mixin that extends an existing class, to be Interactable.
// Usage: Interactable(paper.Shape, this)(...)
export function Interactable(Base, interaction) {
    return class extends Base {
        constructor(...args) {
            super(...args);
            this.interaction = interaction;
        }
    };
}
export function graftInteraction(item, interaction) {
    item.interaction = interaction;
}
// Match function that can be used for paper's hitTest or getItems
// to retrieve an interactable.
export function InteractableMatcher(hit) {
    const item = ('item' in hit ? hit.item : hit);
    return 'interaction' in item && item.visible === true;
}
// Helper method to create a selectAndMove interaction
export function SelectAndMove(c) {
    return { type: "selectAndMove", component: c };
}
// Helper method to create an adjustable interaction.
export function Adjustable(c) {
    return { type: "adjust", component: c };
}
